
import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

export const navigationState = createReducer({}, {
    [types.NAVIGATION_FORWARD](state, action) {
        return state
    },

    [types.NAVIGATION_BACK](state, action) {
        return state
    },

});

export const navigationParams = createReducer({}, {
    [types.NAVIGATION_FORWARD](state, action) {
        return action.state;
    },

});


// WEBPACK FOOTER //
// ./src/reducers/navigation.js